import * as i0 from '@angular/core';
import { Component, Input, TemplateRef, ViewChild, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i2 from 'ng-zorro-antd/tooltip';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from '@va/core-library/common';
import { VaCommonModule } from '@va/core-library/common';
import { faDownload, faSpinner, faPrint, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import * as i2$1 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as i3$1 from 'ng-zorro-antd/spin';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i2$3 from 'ng-zorro-antd/popover';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import * as i3$2 from '@va/core-library/icons';
import { IconsModule } from '@va/core-library/icons';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { faFileExcel } from '@fortawesome/pro-light-svg-icons';
import * as i1$2 from 'ng-zorro-antd/checkbox';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import * as i2$2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NzOverlayModule } from 'ng-zorro-antd/core/overlay';

class DateRendererComponent {
    ngOnInit() {
        this.dateToShow = new Date(this.dateValue);
    }
}
DateRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DateRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DateRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DateRendererComponent, selector: "va-date-renderer", inputs: { dateValue: "dateValue" }, ngImport: i0, template: `
    <span class="grid-date-cell">
      {{ dateToShow | date: "dd-MMM | h:mm a" }}
    </span>
  `, isInline: true, dependencies: [{ kind: "pipe", type: i1.DatePipe, name: "date" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DateRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-date-renderer", template: `
    <span class="grid-date-cell">
      {{ dateToShow | date: "dd-MMM | h:mm a" }}
    </span>
  ` }]
        }], propDecorators: { dateValue: [{
                type: Input
            }] } });

class LinkRendererComponent {
    constructor() {
        this.displayText = "";
        this.url = "";
        this.textEllipsis = 110;
        this.showTooltip = null;
        this.ellipsesTitle = "";
    }
    ngOnChanges() {
        if (!this.clickCallback) {
            this.clickCallback = function () { };
        }
        this.showTooltip =
            this.displayText.length > this.textEllipsis ||
                this.tooltipText !== undefined
                ? true
                : false;
        this.tooltipText =
            this.tooltipText !== undefined
                ? this.tooltipText
                : this.displayText;
        setTimeout(() => {
            if (this.template.elementRef.nativeElement.previousElementSibling) {
                const outter = this.template.elementRef.nativeElement.previousElementSibling.offsetWidth;
                if (this.template.elementRef.nativeElement.previousElementSibling.lastElementChild) {
                    const inner = this.template.elementRef.nativeElement.previousElementSibling
                        .lastElementChild.offsetWidth;
                    if (outter < inner) {
                        this.ellipsesTitle = this.displayText;
                    }
                }
            }
        }, 10);
    }
}
LinkRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LinkRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LinkRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LinkRendererComponent, selector: "va-link-renderer", inputs: { target: "target", displayText: "displayText", tooltipText: "tooltipText", url: "url", textEllipsis: "textEllipsis", clickCallback: "clickCallback", clickData: "clickData" }, viewQueries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <span title="{{ ellipsesTitle }}" (click)="clickCallback(clickData)">
      
      <a
        class="data-cell-link"
        *ngIf="url != '' && !isExternalLink"
        target="{{ target || '_self'}}"
        routerLink="{{ url }}"
        routerLinkActive="active"
      >
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ tooltipText }}"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <a
        class="data-cell-link"
        target="{{ target || '_self'}}"
        *ngIf="url != '' && isExternalLink"
        href="{{ url }}"
      >
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ tooltipText }}"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <span *ngIf="url == ''" class="data-cell-link">
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ tooltipText }}"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </span>
    </span>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NzTooltipDirective, selector: "[nz-tooltip]", inputs: ["nzTooltipTitle", "nzTooltipTitleContext", "nz-tooltip", "nzTooltipTrigger", "nzTooltipPlacement", "nzTooltipOrigin", "nzTooltipVisible", "nzTooltipMouseEnterDelay", "nzTooltipMouseLeaveDelay", "nzTooltipOverlayClassName", "nzTooltipOverlayStyle", "nzTooltipArrowPointAtCenter", "nzTooltipColor"], outputs: ["nzTooltipVisibleChange"], exportAs: ["nzTooltip"] }, { kind: "directive", type: i3.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i3.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "pipe", type: i4.EllipsisPipe, name: "textEllipsis" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LinkRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-link-renderer", template: `
    <span title="{{ ellipsesTitle }}" (click)="clickCallback(clickData)">
      
      <a
        class="data-cell-link"
        *ngIf="url != '' && !isExternalLink"
        target="{{ target || '_self'}}"
        routerLink="{{ url }}"
        routerLinkActive="active"
      >
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ tooltipText }}"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <a
        class="data-cell-link"
        target="{{ target || '_self'}}"
        *ngIf="url != '' && isExternalLink"
        href="{{ url }}"
      >
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ tooltipText }}"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <span *ngIf="url == ''" class="data-cell-link">
        <span
          *ngIf="showTooltip"
          nz-tooltip
          nzTooltipTitle="{{ tooltipText }}"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </span>
    </span>
  ` }]
        }], ctorParameters: function () { return []; }, propDecorators: { target: [{
                type: Input
            }], displayText: [{
                type: Input
            }], tooltipText: [{
                type: Input
            }], url: [{
                type: Input
            }], textEllipsis: [{
                type: Input
            }], template: [{
                type: ViewChild,
                args: [TemplateRef]
            }], clickCallback: [{
                type: Input
            }], clickData: [{
                type: Input
            }] } });

/** @dynamic */ //Otherwise compiler gives error that it is not able to resolve DOCUMENT
class DownloadRendererComponent {
    constructor(_document) {
        this._document = _document;
        this.faDownload = faDownload;
        this.faSpinner = faSpinner;
        this.loading = false;
    }
    onClickDownload(event) {
        this.loading = true;
        const downloadUrl = this.downloadUrl;
        const startIFrameTime = new Date().getTime();
        const iFrameToLoad = this._document.createElement("iframe");
        const body = this._document.getElementsByTagName("body")[0];
        iFrameToLoad.id = `doc_download_iframe_${this.id}`;
        iFrameToLoad.name = `doc_download_iframe_${this.id}`;
        iFrameToLoad.src = downloadUrl;
        iFrameToLoad.setAttribute("style", "visibility:hidden;display:none");
        body.appendChild(iFrameToLoad);
        const checkInterval = setInterval(() => {
            const iFrameToGet = this._document.getElementById(`doc_download_iframe_${this.id}`);
            const iFrame = iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
            /*
              This check will run till the iFrame either doesn't load or for a max of 30secs
              Or till the ready state of the iFrame doesn't evaluate
            */
            if (iFrame.readyState === "complete" ||
                iFrame.readyState === "interactive" ||
                new Date().getTime() - startIFrameTime > 30000) {
                this.loading = false;
                clearInterval(checkInterval);
                return;
            }
        }, 2000);
        this.clickCallback && this.clickCallback(this.id, event);
    }
}
DownloadRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DownloadRendererComponent, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
DownloadRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DownloadRendererComponent, selector: "va-download-renderer", inputs: { show: "show", id: "id", downloadUrl: "downloadUrl", clickCallback: "clickCallback" }, ngImport: i0, template: `
    <p
      *ngIf="show"
      class="clickable"
      (click)="onClickDownload($event)"
    >
      <ng-template #indicatorTemplate
        ><fa-icon [icon]="faSpinner" [spin]="true"></fa-icon
      ></ng-template>
      <nz-spin *ngIf="loading" nzSimple [nzIndicator]="indicatorTemplate">
      </nz-spin>
      <fa-icon *ngIf="!loading" [icon]="faDownload"></fa-icon>
    </p>
  `, isInline: true, styles: [".clickable{cursor:pointer;margin:0}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "spin", "pulse", "mask", "styles", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "classes", "transform", "a11yRole"] }, { kind: "component", type: i3$1.NzSpinComponent, selector: "nz-spin", inputs: ["nzIndicator", "nzSize", "nzTip", "nzDelay", "nzSimple", "nzSpinning"], exportAs: ["nzSpin"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DownloadRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-download-renderer", template: `
    <p
      *ngIf="show"
      class="clickable"
      (click)="onClickDownload($event)"
    >
      <ng-template #indicatorTemplate
        ><fa-icon [icon]="faSpinner" [spin]="true"></fa-icon
      ></ng-template>
      <nz-spin *ngIf="loading" nzSimple [nzIndicator]="indicatorTemplate">
      </nz-spin>
      <fa-icon *ngIf="!loading" [icon]="faDownload"></fa-icon>
    </p>
  `, styles: [".clickable{cursor:pointer;margin:0}\n"] }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { show: [{
                type: Input
            }], id: [{
                type: Input
            }], downloadUrl: [{
                type: Input
            }], clickCallback: [{
                type: Input
            }] } });

class PrintRendererComponent {
    constructor(http) {
        this.http = http;
        this.isDefaultHandling = true; // whether to use default handling on click of icon
        this.faPrint = faPrint;
        this.faSpinner = faSpinner;
        this.loading = false;
    }
    getPrintDocumentURL(documentId) {
        const jsonData = {
            document_id: [documentId]
        };
        return this.http.post(this.documentGetUrl, jsonData);
    }
    onClickPrint(event, docId) {
        // If default handling should be done on click of print icon,
        // if not, then only callback will be called and the user has to handle the print action.
        if (this.isDefaultHandling) {
            this.loading = true;
            this.getPrintDocumentURL(docId).subscribe((data) => {
                let printUrl = encodeURIComponent(data.Data.Url);
                printUrl = `${this.baseUrl}/pdfviewer?file=${printUrl}#printonload=true&closeafterprint=true`;
                window.open(printUrl, "_blank");
                this.loading = false;
            }, () => {
                console.error("Getting print document failed");
                this.loading = false;
            });
        }
        this.printCallback && this.printCallback(event, docId);
    }
}
PrintRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PrintRendererComponent, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Component });
PrintRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: PrintRendererComponent, selector: "va-print-renderer", inputs: { show: "show", isDefaultHandling: "isDefaultHandling", docId: "docId", baseUrl: "baseUrl", documentGetUrl: "documentGetUrl", printCallback: "printCallback" }, ngImport: i0, template: `
    <p *ngIf="show" class="clickable" (click)="onClickPrint($event, docId)">
      <ng-template #indicatorTemplate
        ><fa-icon [icon]="faSpinner" [spin]="true"></fa-icon
      ></ng-template>
      <nz-spin *ngIf="loading" nzSimple [nzIndicator]="indicatorTemplate">
      </nz-spin>
      <fa-icon *ngIf="!loading" [icon]="faPrint"></fa-icon>
    </p>
  `, isInline: true, styles: [".clickable{cursor:pointer;margin:0}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "spin", "pulse", "mask", "styles", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "classes", "transform", "a11yRole"] }, { kind: "component", type: i3$1.NzSpinComponent, selector: "nz-spin", inputs: ["nzIndicator", "nzSize", "nzTip", "nzDelay", "nzSimple", "nzSpinning"], exportAs: ["nzSpin"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PrintRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-print-renderer", template: `
    <p *ngIf="show" class="clickable" (click)="onClickPrint($event, docId)">
      <ng-template #indicatorTemplate
        ><fa-icon [icon]="faSpinner" [spin]="true"></fa-icon
      ></ng-template>
      <nz-spin *ngIf="loading" nzSimple [nzIndicator]="indicatorTemplate">
      </nz-spin>
      <fa-icon *ngIf="!loading" [icon]="faPrint"></fa-icon>
    </p>
  `, styles: [".clickable{cursor:pointer;margin:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; }, propDecorators: { show: [{
                type: Input
            }], isDefaultHandling: [{
                type: Input
            }], docId: [{
                type: Input
            }], baseUrl: [{
                type: Input
            }], documentGetUrl: [{
                type: Input
            }], printCallback: [{
                type: Input
            }] } });

class AnalystRendererComponent {
    ngOnInit() {
        if (this.analysts.length > 1) {
            this.displayName = this.analysts.map((value) => {
                return value.isPrimary ? value.displayName : undefined;
            })[0];
            this.tooltipVal = this.analysts
                .map((val) => {
                return val.displayName !== this.displayName
                    ? val.displayName
                    : undefined;
            })
                .filter((v) => v !== void 0)
                .join(", ");
        }
        else if (this.analysts.length === 1) {
            this.displayName = this.analysts[0].displayName;
            this.tooltipVal = "";
        }
    }
}
AnalystRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AnalystRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AnalystRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AnalystRendererComponent, selector: "va-analyst-renderer", inputs: { analysts: "analysts" }, ngImport: i0, template: `
    <span *ngIf="tooltipVal == ''">
      {{ displayName }}
    </span>
    <span
      class="show-tooltip"
      *ngIf="tooltipVal != ''"
      nz-tooltip
      nzTooltipTitle="Additional analysts: {{ tooltipVal }}"
    >
      {{ displayName }}
    </span>
  `, isInline: true, styles: [".show-tooltip{cursor:pointer}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NzTooltipDirective, selector: "[nz-tooltip]", inputs: ["nzTooltipTitle", "nzTooltipTitleContext", "nz-tooltip", "nzTooltipTrigger", "nzTooltipPlacement", "nzTooltipOrigin", "nzTooltipVisible", "nzTooltipMouseEnterDelay", "nzTooltipMouseLeaveDelay", "nzTooltipOverlayClassName", "nzTooltipOverlayStyle", "nzTooltipArrowPointAtCenter", "nzTooltipColor"], outputs: ["nzTooltipVisibleChange"], exportAs: ["nzTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AnalystRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-analyst-renderer", template: `
    <span *ngIf="tooltipVal == ''">
      {{ displayName }}
    </span>
    <span
      class="show-tooltip"
      *ngIf="tooltipVal != ''"
      nz-tooltip
      nzTooltipTitle="Additional analysts: {{ tooltipVal }}"
    >
      {{ displayName }}
    </span>
  `, styles: [".show-tooltip{cursor:pointer}\n"] }]
        }], propDecorators: { analysts: [{
                type: Input
            }] } });

class IconLinkRendererComponent {
    constructor() {
        this.isTextNotLink = false;
        this.iconPosition = "start";
        this.isDisabled = false;
        this.iconSize = "small";
        this.hasText = false;
    }
    ngOnInit() {
        this.clickCallback = this.clickCallback || function () { };
        this.hasText = this.linkText !== undefined;
        this.iconPosition = this.iconPosition || 'start';
        this.iconSize = this.iconSize || 'small';
    }
}
IconLinkRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IconLinkRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconLinkRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IconLinkRendererComponent, selector: "va-icon-link-renderer", inputs: { linkText: "linkText", isTextNotLink: "isTextNotLink", iconPosition: "iconPosition", clickCallback: "clickCallback", clickData: "clickData", title: "title", icon: "icon", isDisabled: "isDisabled", iconSize: "iconSize", iconColor: "iconColor", show: "show" }, ngImport: i0, template: `
    <span
      *ngIf="show"
    >
      <span
        class="icon-text" 
        *ngIf="hasText && iconPosition === 'end' "
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"  
      >
        <span>
          {{ linkText }}
        </span>
      </span>
      <span
        class="icon-link"
        *ngIf="icon"
        [ngStyle]="{
          color: iconColor || '#1874ae'
        }"
      >
        <va-icon
          [size]="iconSize"
          [name]="icon"
          [ngClass]="{ 'disabled': isDisabled }"
          nz-tooltip
          nzTooltipTitle="{{ title }}"
          (click)="clickCallback(clickData)"
        ></va-icon>
      </span>
      <span
        class="icon-text"
        *ngIf="hasText && iconPosition === 'start'"
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"
      >
        <span>
          {{ linkText }}
        </span>
      </span>
    </span>
  `, isInline: true, styles: [".icon-link{font-size:14px;& va-icon:not(.disabled){cursor:pointer}& va-icon.disabled{pointer-events:none;color:#d3d7dd}}.icon-text{font-size:12px;&.disabled{pointer-events:none;color:#d3d7dd}}.link-text{color:#1874ae;&:not(.disabled){cursor:pointer}&.disabled{pointer-events:none;color:#d3d7dd}}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2.NzTooltipDirective, selector: "[nz-tooltip]", inputs: ["nzTooltipTitle", "nzTooltipTitleContext", "nz-tooltip", "nzTooltipTrigger", "nzTooltipPlacement", "nzTooltipOrigin", "nzTooltipVisible", "nzTooltipMouseEnterDelay", "nzTooltipMouseLeaveDelay", "nzTooltipOverlayClassName", "nzTooltipOverlayStyle", "nzTooltipArrowPointAtCenter", "nzTooltipColor"], outputs: ["nzTooltipVisibleChange"], exportAs: ["nzTooltip"] }, { kind: "component", type: i3$2.IconComponent, selector: "va-icon", inputs: ["spin", "isFontAwesome", "styles", "size", "name"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IconLinkRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-icon-link-renderer", template: `
    <span
      *ngIf="show"
    >
      <span
        class="icon-text" 
        *ngIf="hasText && iconPosition === 'end' "
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"  
      >
        <span>
          {{ linkText }}
        </span>
      </span>
      <span
        class="icon-link"
        *ngIf="icon"
        [ngStyle]="{
          color: iconColor || '#1874ae'
        }"
      >
        <va-icon
          [size]="iconSize"
          [name]="icon"
          [ngClass]="{ 'disabled': isDisabled }"
          nz-tooltip
          nzTooltipTitle="{{ title }}"
          (click)="clickCallback(clickData)"
        ></va-icon>
      </span>
      <span
        class="icon-text"
        *ngIf="hasText && iconPosition === 'start'"
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"
      >
        <span>
          {{ linkText }}
        </span>
      </span>
    </span>
  `, styles: [".icon-link{font-size:14px;& va-icon:not(.disabled){cursor:pointer}& va-icon.disabled{pointer-events:none;color:#d3d7dd}}.icon-text{font-size:12px;&.disabled{pointer-events:none;color:#d3d7dd}}.link-text{color:#1874ae;&:not(.disabled){cursor:pointer}&.disabled{pointer-events:none;color:#d3d7dd}}\n"] }]
        }], propDecorators: { linkText: [{
                type: Input
            }], isTextNotLink: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], clickCallback: [{
                type: Input
            }], clickData: [{
                type: Input
            }], title: [{
                type: Input
            }], icon: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], iconSize: [{
                type: Input
            }], iconColor: [{
                type: Input
            }], show: [{
                type: Input
            }] } });

class ReportingViewLinkRendererComponent {
    ngOnInit() {
        this.faInfo = faInfoCircle;
    }
}
ReportingViewLinkRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ReportingViewLinkRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ReportingViewLinkRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ReportingViewLinkRendererComponent, selector: "va-reporting-view-link-renderer", inputs: { show: "show", showAnalyst: "showAnalyst", showDashboard: "showDashboard", dashboardLink: "dashboardLink", showAnalystInfoIcon: "showAnalystInfoIcon", analystLink: "analystLink" }, ngImport: i0, template: `
    <div *ngIf="show">
      <div
        *ngIf="showAnalyst"
        class="analyst-link"
        title="View Analysts As-
published View"
      >
        <a routerLink="{{ analystLink }}">
          <span class="link">ANALYST</span>
          <span class="analyst-icon">
            <fa-icon
              *ngIf="showAnalystInfoIcon"
              [icon]="faInfo"
              title="View Analyst As 
Reported Only View"
            >
            </fa-icon>
          </span>
        </a>
      </div>
      <div
        *ngIf="showDashboard"
        class="dashboard-link"
        title="View Analysts Dashboard"
      >
        <a routerLink="{{ dashboardLink }}" routerLinkActive="active">
          <span class="link">DASHBOARD</span>
        </a>
      </div>
    </div>
  `, isInline: true, styles: [".analyst-link{background-color:#4169e1;color:#fff;padding:2px 5px;margin-right:5px;display:inline-block}.dashboard-link{background-color:#6b8e23;color:#fff!important;padding:2px 5px;display:inline-block}.link{color:#fff;font-size:12px}.analyst-icon{font-size:10px;color:#fff;padding-left:4px}a:hover{color:#fff}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "spin", "pulse", "mask", "styles", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "classes", "transform", "a11yRole"] }, { kind: "directive", type: i3.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i3.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ReportingViewLinkRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-reporting-view-link-renderer", template: `
    <div *ngIf="show">
      <div
        *ngIf="showAnalyst"
        class="analyst-link"
        title="View Analysts As-
published View"
      >
        <a routerLink="{{ analystLink }}">
          <span class="link">ANALYST</span>
          <span class="analyst-icon">
            <fa-icon
              *ngIf="showAnalystInfoIcon"
              [icon]="faInfo"
              title="View Analyst As 
Reported Only View"
            >
            </fa-icon>
          </span>
        </a>
      </div>
      <div
        *ngIf="showDashboard"
        class="dashboard-link"
        title="View Analysts Dashboard"
      >
        <a routerLink="{{ dashboardLink }}" routerLinkActive="active">
          <span class="link">DASHBOARD</span>
        </a>
      </div>
    </div>
  `, styles: [".analyst-link{background-color:#4169e1;color:#fff;padding:2px 5px;margin-right:5px;display:inline-block}.dashboard-link{background-color:#6b8e23;color:#fff!important;padding:2px 5px;display:inline-block}.link{color:#fff;font-size:12px}.analyst-icon{font-size:10px;color:#fff;padding-left:4px}a:hover{color:#fff}\n"] }]
        }], propDecorators: { show: [{
                type: Input
            }], showAnalyst: [{
                type: Input
            }], showDashboard: [{
                type: Input
            }], dashboardLink: [{
                type: Input
            }], showAnalystInfoIcon: [{
                type: Input
            }], analystLink: [{
                type: Input
            }] } });

class ReportingModelRendererComponent {
    constructor() {
        this.faFileExcel = faFileExcel;
        this.faInfoCircle = faExclamationCircle;
        this.sourceStatus = "";
        this.disabled = false;
        this.title = "";
        this.showInfoIcon = false;
        this.BAML_SOURCEID = 3;
    }
    ngOnInit() {
        const rowObjectStatus = this.sourceStatus
            ? this.sourceStatus.toLowerCase()
            : "";
        if ("restrict" === rowObjectStatus ||
            "review" === rowObjectStatus ||
            "review_extended" === rowObjectStatus) {
            this.title = "No Current Model.";
            this.showInfoIcon = true;
        }
        else if (this.entitled && !this.downloadApplicable) {
            // TODO : change the text for BAML to BOFA later
            this.title = "A downloadable model is not currently available.";
            this.disabled = true;
        }
        else if (this.entitled) {
            this.title = "Download Current Model";
            this.disabled = false;
        }
        else {
            this.title = "You are not entitled\nto download this model.";
            this.disabled = true;
        }
    }
}
ReportingModelRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ReportingModelRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ReportingModelRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ReportingModelRendererComponent, selector: "va-reporting-model-renderer", inputs: { sourceStatus: "sourceStatus", entitled: "entitled", downloadApplicable: "downloadApplicable", clickCallback: "clickCallback", clickData: "clickData", linkText: "linkText" }, ngImport: i0, template: `
    <span>
      <span
        class="icon-link"
        *ngIf="!disabled && !showInfoIcon"
        (click)="clickCallback(clickData)"
        nz-tooltip
        nzTooltipTitle="{{ title }}"
      >
        <fa-icon [icon]="faFileExcel" class="link-icon"></fa-icon>
        <span class="icon-text">
          <span>
            {{ linkText }}
          </span>
        </span>
      </span>
      <span
        class="icon-link disabled"
        *ngIf="disabled && !showInfoIcon"
        nz-tooltip
        nzTooltipTitle="{{ title }}"
      >
        <fa-icon [icon]="faFileExcel" class="link-icon"></fa-icon>
        <span class="icon-text">
          {{ linkText }}
        </span>
      </span>
      <span
        class="icon-link"
        *ngIf="showInfoIcon"
        nz-tooltip
        nzTooltipTitle="{{ title }}"
      >
        <fa-icon [icon]="faInfoCircle" class="link-icon-info"></fa-icon>
      </span>
    </span>
  `, isInline: true, styles: [".icon-link{cursor:pointer;color:#000;font-size:14px}.icon-text{cursor:pointer;color:#1874ae;font-size:12px}.disabled{opacity:.4}.link-icon-info{cursor:pointer;color:#36abad;font-size:14px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "spin", "pulse", "mask", "styles", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "classes", "transform", "a11yRole"] }, { kind: "directive", type: i2.NzTooltipDirective, selector: "[nz-tooltip]", inputs: ["nzTooltipTitle", "nzTooltipTitleContext", "nz-tooltip", "nzTooltipTrigger", "nzTooltipPlacement", "nzTooltipOrigin", "nzTooltipVisible", "nzTooltipMouseEnterDelay", "nzTooltipMouseLeaveDelay", "nzTooltipOverlayClassName", "nzTooltipOverlayStyle", "nzTooltipArrowPointAtCenter", "nzTooltipColor"], outputs: ["nzTooltipVisibleChange"], exportAs: ["nzTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ReportingModelRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-reporting-model-renderer", template: `
    <span>
      <span
        class="icon-link"
        *ngIf="!disabled && !showInfoIcon"
        (click)="clickCallback(clickData)"
        nz-tooltip
        nzTooltipTitle="{{ title }}"
      >
        <fa-icon [icon]="faFileExcel" class="link-icon"></fa-icon>
        <span class="icon-text">
          <span>
            {{ linkText }}
          </span>
        </span>
      </span>
      <span
        class="icon-link disabled"
        *ngIf="disabled && !showInfoIcon"
        nz-tooltip
        nzTooltipTitle="{{ title }}"
      >
        <fa-icon [icon]="faFileExcel" class="link-icon"></fa-icon>
        <span class="icon-text">
          {{ linkText }}
        </span>
      </span>
      <span
        class="icon-link"
        *ngIf="showInfoIcon"
        nz-tooltip
        nzTooltipTitle="{{ title }}"
      >
        <fa-icon [icon]="faInfoCircle" class="link-icon-info"></fa-icon>
      </span>
    </span>
  `, styles: [".icon-link{cursor:pointer;color:#000;font-size:14px}.icon-text{cursor:pointer;color:#1874ae;font-size:12px}.disabled{opacity:.4}.link-icon-info{cursor:pointer;color:#36abad;font-size:14px}\n"] }]
        }], propDecorators: { sourceStatus: [{
                type: Input
            }], entitled: [{
                type: Input
            }], downloadApplicable: [{
                type: Input
            }], clickCallback: [{
                type: Input
            }], clickData: [{
                type: Input
            }], linkText: [{
                type: Input
            }] } });

class MultiIconRendererComponent {
    constructor() {
        this.iconObjList = [];
    }
    ngOnInit() {
        this.iconObjList.forEach((element) => {
            element.hasCallBack = !!element.clickCallback;
            element.hasText = !!element.linkText;
            element.iconSize = element.iconSize || 'small';
        });
    }
}
MultiIconRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MultiIconRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MultiIconRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: MultiIconRendererComponent, selector: "va-multi-icon-renderer", inputs: { iconObjList: "iconObjList" }, ngImport: i0, template: `
    <div class="multi-icons">
      <div *ngFor="let linkObj of iconObjList" class="icon">
        <span *ngIf="linkObj.show" [ngClass]="linkObj.className">
          <span class="icon-link" *ngIf="linkObj.hasCallBack">
            <va-icon
              [size]="linkObj.iconSize"
              [name]="linkObj.icon"
              class="link-icon"
              nz-tooltip
              nzTooltipTitle="{{ linkObj.title }}"
              (click)="linkObj.clickCallback(linkObj.clickData)"
            ></va-icon>
          </span>
          <span class="icon-link" *ngIf="!linkObj.hasCallBack">
            <va-icon
              [size]="linkObj.iconSize"
              [name]="linkObj.icon"
              class="link-icon"
              nz-tooltip
              nzTooltipTitle="{{ linkObj.title }}"
            ></va-icon>
          </span>
          <span class="icon-text" *ngIf="linkObj.hasText">
            <span (click)="linkObj.clickCallback(linkObj.clickData)">
              {{ linkObj.linkText }}
            </span>
          </span>
        </span>
      </div>
    </div>
  `, isInline: true, styles: [".multi-icons{display:flex}.icon{margin-right:8px}.icon-link{cursor:pointer;font-size:14px}.icon-text{cursor:pointer;font-size:12px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NzTooltipDirective, selector: "[nz-tooltip]", inputs: ["nzTooltipTitle", "nzTooltipTitleContext", "nz-tooltip", "nzTooltipTrigger", "nzTooltipPlacement", "nzTooltipOrigin", "nzTooltipVisible", "nzTooltipMouseEnterDelay", "nzTooltipMouseLeaveDelay", "nzTooltipOverlayClassName", "nzTooltipOverlayStyle", "nzTooltipArrowPointAtCenter", "nzTooltipColor"], outputs: ["nzTooltipVisibleChange"], exportAs: ["nzTooltip"] }, { kind: "component", type: i3$2.IconComponent, selector: "va-icon", inputs: ["spin", "isFontAwesome", "styles", "size", "name"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: MultiIconRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-multi-icon-renderer", template: `
    <div class="multi-icons">
      <div *ngFor="let linkObj of iconObjList" class="icon">
        <span *ngIf="linkObj.show" [ngClass]="linkObj.className">
          <span class="icon-link" *ngIf="linkObj.hasCallBack">
            <va-icon
              [size]="linkObj.iconSize"
              [name]="linkObj.icon"
              class="link-icon"
              nz-tooltip
              nzTooltipTitle="{{ linkObj.title }}"
              (click)="linkObj.clickCallback(linkObj.clickData)"
            ></va-icon>
          </span>
          <span class="icon-link" *ngIf="!linkObj.hasCallBack">
            <va-icon
              [size]="linkObj.iconSize"
              [name]="linkObj.icon"
              class="link-icon"
              nz-tooltip
              nzTooltipTitle="{{ linkObj.title }}"
            ></va-icon>
          </span>
          <span class="icon-text" *ngIf="linkObj.hasText">
            <span (click)="linkObj.clickCallback(linkObj.clickData)">
              {{ linkObj.linkText }}
            </span>
          </span>
        </span>
      </div>
    </div>
  `, styles: [".multi-icons{display:flex}.icon{margin-right:8px}.icon-link{cursor:pointer;font-size:14px}.icon-text{cursor:pointer;font-size:12px}\n"] }]
        }], propDecorators: { iconObjList: [{
                type: Input
            }] } });

class CheckboxRendererComponent {
    ngOnInit() {
        if (this.disabled === undefined) {
            this.disabled = false;
        }
    }
    updateCheckbox() {
        this.callUpdateCallback({
            disabled: this.disabled,
            callUpdateCallback: this.callUpdateCallback,
            checked: this.checked,
            value: this.value,
            text: this.text,
        });
    }
}
CheckboxRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckboxRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CheckboxRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: CheckboxRendererComponent, selector: "va-checkbox-renderer", inputs: { disabled: "disabled", callUpdateCallback: "callUpdateCallback", checked: "checked", value: "value", text: "text" }, ngImport: i0, template: `
    <label
      nz-checkbox
      [(ngModel)]="checked"
      [nzValue]="value"
      [nzDisabled]="disabled"
      (ngModelChange)="updateCheckbox()"
      >{{ text }}</label
    >
  `, isInline: true, dependencies: [{ kind: "component", type: i1$2.NzCheckboxComponent, selector: "[nz-checkbox]", inputs: ["nzValue", "nzAutoFocus", "nzDisabled", "nzIndeterminate", "nzChecked", "nzId"], outputs: ["nzCheckedChange"], exportAs: ["nzCheckbox"] }, { kind: "directive", type: i2$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CheckboxRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "va-checkbox-renderer", template: `
    <label
      nz-checkbox
      [(ngModel)]="checked"
      [nzValue]="value"
      [nzDisabled]="disabled"
      (ngModelChange)="updateCheckbox()"
      >{{ text }}</label
    >
  ` }]
        }], propDecorators: { disabled: [{
                type: Input
            }], callUpdateCallback: [{
                type: Input
            }], checked: [{
                type: Input
            }], value: [{
                type: Input
            }], text: [{
                type: Input
            }] } });

class BadgeRendererComponent {
    constructor() {
        this.text = "";
        this.textColor = "#000000";
    }
    ngOnInit() {
    }
}
BadgeRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BadgeRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BadgeRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: BadgeRendererComponent, selector: "va-badge-renderer", inputs: { text: "text", textColor: "textColor", badgeColor: "badgeColor" }, ngImport: i0, template: `
    <span
      class="va-badge-renderer"
      [ngStyle]="{'background-color': badgeColor, color: textColor}"
      >
      {{text}}
    </span>
  `, isInline: true, styles: [".va-badge-renderer{border-radius:4px;padding:0 8px}\n"], dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: BadgeRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-badge-renderer', template: `
    <span
      class="va-badge-renderer"
      [ngStyle]="{'background-color': badgeColor, color: textColor}"
      >
      {{text}}
    </span>
  `, styles: [".va-badge-renderer{border-radius:4px;padding:0 8px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { text: [{
                type: Input
            }], textColor: [{
                type: Input
            }], badgeColor: [{
                type: Input
            }] } });

class ColoredTextRendererComponent {
    constructor() { }
    ngOnInit() {
        this.clickCallback = this.clickCallback || function () { };
    }
}
ColoredTextRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ColoredTextRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ColoredTextRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: ColoredTextRendererComponent, selector: "va-colored-text-renderer", inputs: { text: "text", textColor: "textColor", clickCallback: "clickCallback", clickData: "clickData" }, ngImport: i0, template: `
    <div
      [ngStyle]="{ color: textColor }"
      (click)="clickCallback(clickData)"
      class="cursor-default"
    >
      {{text}}
    </div>
  `, isInline: true, styles: [".cursor-default{cursor:default}\n"], dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ColoredTextRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-colored-text-renderer', template: `
    <div
      [ngStyle]="{ color: textColor }"
      (click)="clickCallback(clickData)"
      class="cursor-default"
    >
      {{text}}
    </div>
  `, styles: [".cursor-default{cursor:default}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { text: [{
                type: Input
            }], textColor: [{
                type: Input
            }], clickCallback: [{
                type: Input
            }], clickData: [{
                type: Input
            }] } });

class TargetPricingLastChangeRendererComponent {
    constructor() {
        this.iconClickCallback = () => { };
        this.clickCallback = () => { };
    }
    ngOnInit() {
        this.dateToShow = new Date(this.dateValue);
    }
}
TargetPricingLastChangeRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TargetPricingLastChangeRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TargetPricingLastChangeRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TargetPricingLastChangeRendererComponent, selector: "va-target-pricing-last-change-renderer", inputs: { dateValue: "dateValue", dayDiff: "dayDiff", icon: "icon", iconColor: "iconColor", textTooltip: "textTooltip", iconTooltip: "iconTooltip", iconClickCallback: "iconClickCallback", iconClickData: "iconClickData", clickCallback: "clickCallback", clickData: "clickData" }, ngImport: i0, template: `
    <span (click)="clickCallback(clickData)" *ngIf="dateValue && dateToShow" class="cursor-default">
      <span
        class="grid-date-cell"
        nz-popover
        [nzPopoverTrigger]="'hover'"
        [nzPopoverPlacement]="'right'"
        [nzPopoverContent]="textTooltip"
      >
        {{ dateToShow | date: "dd-MMM-yy" }} ({{dayDiff}})
      </span>
      <span
        *ngIf="icon"
        [ngStyle]="{
          color: iconColor || '#1874ae'
        }"
      >
        <va-icon
          (click)="iconClickCallback(iconClickData)"
          [name]="icon"
          size="small"
          nz-popover
          [nzPopoverContent]="iconTooltip"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          nzPopoverOverlayClassName="tp-last-change-icon-popover"
        ></va-icon>
      </span>
    </span>
  `, isInline: true, styles: ["::ng-deep .tp-last-change-icon-popover{max-width:236px}.cursor-default{cursor:default}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2$3.NzPopoverDirective, selector: "[nz-popover]", inputs: ["nzPopoverArrowPointAtCenter", "nzPopoverTitle", "nzPopoverContent", "nz-popover", "nzPopoverTrigger", "nzPopoverPlacement", "nzPopoverOrigin", "nzPopoverVisible", "nzPopoverMouseEnterDelay", "nzPopoverMouseLeaveDelay", "nzPopoverOverlayClassName", "nzPopoverOverlayStyle", "nzPopoverBackdrop"], outputs: ["nzPopoverVisibleChange"], exportAs: ["nzPopover"] }, { kind: "component", type: i3$2.IconComponent, selector: "va-icon", inputs: ["spin", "isFontAwesome", "styles", "size", "name"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TargetPricingLastChangeRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-target-pricing-last-change-renderer', template: `
    <span (click)="clickCallback(clickData)" *ngIf="dateValue && dateToShow" class="cursor-default">
      <span
        class="grid-date-cell"
        nz-popover
        [nzPopoverTrigger]="'hover'"
        [nzPopoverPlacement]="'right'"
        [nzPopoverContent]="textTooltip"
      >
        {{ dateToShow | date: "dd-MMM-yy" }} ({{dayDiff}})
      </span>
      <span
        *ngIf="icon"
        [ngStyle]="{
          color: iconColor || '#1874ae'
        }"
      >
        <va-icon
          (click)="iconClickCallback(iconClickData)"
          [name]="icon"
          size="small"
          nz-popover
          [nzPopoverContent]="iconTooltip"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          nzPopoverOverlayClassName="tp-last-change-icon-popover"
        ></va-icon>
      </span>
    </span>
  `, styles: ["::ng-deep .tp-last-change-icon-popover{max-width:236px}.cursor-default{cursor:default}\n"] }]
        }], propDecorators: { dateValue: [{
                type: Input
            }], dayDiff: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconColor: [{
                type: Input
            }], textTooltip: [{
                type: Input
            }], iconTooltip: [{
                type: Input
            }], iconClickCallback: [{
                type: Input
            }], iconClickData: [{
                type: Input
            }], clickCallback: [{
                type: Input
            }], clickData: [{
                type: Input
            }] } });

class TargetPricingAnalystRendererComponent {
    constructor() {
        this.displayText = "";
        this.url = "";
        this.textEllipsis = 110;
        this.emailClickCallback = function () { };
        this.showTooltip = null;
        this.ellipsesTitle = "";
    }
    ngOnChanges() {
        this.showTooltip =
            (this.displayText && this.displayText.length > this.textEllipsis) ||
                this.name !== undefined
                ? true
                : false;
        // don't move it before showTooltip
        this.name =
            this.name !== undefined
                ? this.name
                : this.displayText;
        setTimeout(() => {
            const outer = this.template.elementRef.nativeElement.nextSibling
                .offsetWidth;
            if (this.template.elementRef.nativeElement.nextSibling.lastElementChild) {
                const inner = this.template.elementRef.nativeElement.nextSibling
                    .lastElementChild.offsetWidth;
                if (outer < inner) {
                    this.ellipsesTitle = this.displayText;
                }
            }
        }, 10);
    }
}
TargetPricingAnalystRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TargetPricingAnalystRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TargetPricingAnalystRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TargetPricingAnalystRendererComponent, selector: "va-target-pricing-analyst-renderer", inputs: { target: "target", displayText: "displayText", name: "name", nameLink: "nameLink", broker: "broker", brokerLink: "brokerLink", email: "email", url: "url", textEllipsis: "textEllipsis", emailClickCallback: "emailClickCallback", emailClickData: "emailClickData" }, viewQueries: [{ propertyName: "template", first: true, predicate: TemplateRef, descendants: true }], usesOnChanges: true, ngImport: i0, template: `
    <span title="{{ ellipsesTitle }}">
      <a
        class="data-cell-link"
        *ngIf="url != '' && !isExternalLink"
        target="{{ target }}"
        routerLink="{{ url }}"
        routerLinkActive="active"
      >
        <span
          *ngIf="showTooltip"
          nz-popover
          [nzPopoverContent]="contentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          [nzPopoverOverlayClassName]="'tpanalyst-popover'"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <a
        class="data-cell-link"
        target="{{ target }}"
        *ngIf="url != '' && isExternalLink"
        href="{{ url }}"
      >
        <span
          *ngIf="showTooltip"
          nz-popover
          [nzPopoverContent]="contentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          [nzPopoverOverlayClassName]="'tpanalyst-popover'"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <span *ngIf="url == ''" class="data-cell-link">
        <span
          *ngIf="showTooltip"
          nz-popover
          [nzPopoverContent]="contentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          [nzPopoverOverlayClassName]="'tpanalyst-popover'"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </span>

      <ng-template #contentTemplate>
        <div>
          <a
            routerLink="{{ nameLink }}"
            routerLinkActive="active"
            class="name"
            >{{ name }}</a
          ><br />
          <a
            routerLink="{{ brokerLink }}"
            class="broker"
            >{{ broker }} Home</a
          ><br />
          <div (click)="emailClickCallback(emailClickData)">
          <a
          href="mailto:{{ email }}"
          class="email"
        >
          {{ email }}</a
        >
          </div>
        </div>
      </ng-template>
    </span>
  `, isInline: true, styles: ["::ng-deep .tpanalyst-popover a.name{font-size:16px;font-weight:400;color:#000;&:hover{color:#000}}::ng-deep .tpanalyst-popover a.email{font-size:12px;font-weight:400;color:#3274a9}::ng-deep .tpanalyst-popover a.broker{font-size:12px;font-weight:400;color:#3274a9}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$3.NzPopoverDirective, selector: "[nz-popover]", inputs: ["nzPopoverArrowPointAtCenter", "nzPopoverTitle", "nzPopoverContent", "nz-popover", "nzPopoverTrigger", "nzPopoverPlacement", "nzPopoverOrigin", "nzPopoverVisible", "nzPopoverMouseEnterDelay", "nzPopoverMouseLeaveDelay", "nzPopoverOverlayClassName", "nzPopoverOverlayStyle", "nzPopoverBackdrop"], outputs: ["nzPopoverVisibleChange"], exportAs: ["nzPopover"] }, { kind: "directive", type: i3.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i3.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "ariaCurrentWhenActive", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }, { kind: "pipe", type: i4.EllipsisPipe, name: "textEllipsis" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TargetPricingAnalystRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-target-pricing-analyst-renderer', template: `
    <span title="{{ ellipsesTitle }}">
      <a
        class="data-cell-link"
        *ngIf="url != '' && !isExternalLink"
        target="{{ target }}"
        routerLink="{{ url }}"
        routerLinkActive="active"
      >
        <span
          *ngIf="showTooltip"
          nz-popover
          [nzPopoverContent]="contentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          [nzPopoverOverlayClassName]="'tpanalyst-popover'"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <a
        class="data-cell-link"
        target="{{ target }}"
        *ngIf="url != '' && isExternalLink"
        href="{{ url }}"
      >
        <span
          *ngIf="showTooltip"
          nz-popover
          [nzPopoverContent]="contentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          [nzPopoverOverlayClassName]="'tpanalyst-popover'"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </a>
      <span *ngIf="url == ''" class="data-cell-link">
        <span
          *ngIf="showTooltip"
          nz-popover
          [nzPopoverContent]="contentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          [nzPopoverOverlayClassName]="'tpanalyst-popover'"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
        <span
          *ngIf="!showTooltip"
          [innerHtml]="displayText | textEllipsis: textEllipsis"
        ></span>
      </span>

      <ng-template #contentTemplate>
        <div>
          <a
            routerLink="{{ nameLink }}"
            routerLinkActive="active"
            class="name"
            >{{ name }}</a
          ><br />
          <a
            routerLink="{{ brokerLink }}"
            class="broker"
            >{{ broker }} Home</a
          ><br />
          <div (click)="emailClickCallback(emailClickData)">
          <a
          href="mailto:{{ email }}"
          class="email"
        >
          {{ email }}</a
        >
          </div>
        </div>
      </ng-template>
    </span>
  `, styles: ["::ng-deep .tpanalyst-popover a.name{font-size:16px;font-weight:400;color:#000;&:hover{color:#000}}::ng-deep .tpanalyst-popover a.email{font-size:12px;font-weight:400;color:#3274a9}::ng-deep .tpanalyst-popover a.broker{font-size:12px;font-weight:400;color:#3274a9}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { target: [{
                type: Input
            }], displayText: [{
                type: Input
            }], name: [{
                type: Input
            }], nameLink: [{
                type: Input
            }], broker: [{
                type: Input
            }], brokerLink: [{
                type: Input
            }], email: [{
                type: Input
            }], url: [{
                type: Input
            }], textEllipsis: [{
                type: Input
            }], template: [{
                type: ViewChild,
                args: [TemplateRef]
            }], emailClickCallback: [{
                type: Input
            }], emailClickData: [{
                type: Input
            }] } });

class TargetPricingConsensusRendererComponent extends IconLinkRendererComponent {
    constructor() {
        super();
    }
}
TargetPricingConsensusRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TargetPricingConsensusRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TargetPricingConsensusRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: TargetPricingConsensusRendererComponent, selector: "va-target-pricing-consensus-renderer", inputs: { email: "email", iconTooltipHeader: "iconTooltipHeader", iconTooltip: "iconTooltip" }, usesInheritance: true, ngImport: i0, template: `
    <span
      *ngIf="show"
      class="tpr-consensus"
    >
      <span
        class="icon-text" 
        *ngIf="hasText && iconPosition === 'end' "
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"  
      >
        <span>
          {{ linkText }}
        </span>
      </span>
      <span
        class="icon-link"
        *ngIf="icon"
        [ngStyle]="{
          color: iconColor || '#1874ae'
        }"
      >
        <va-icon
          [size]="iconSize"
          [name]="icon"
          [ngClass]="{ 'disabled': isDisabled }"
          nz-popover
          [nzPopoverTitle]="notCurrentTitle"
          [nzPopoverContent]="notCurrentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          nzPopoverWidth="20px"
          [nzPopoverOverlayClassName]="'va-tpr-consensus-popover'"
          (click)="clickCallback(clickData)"
        ></va-icon>
      </span>
      <span
        class="icon-text"
        *ngIf="hasText && iconPosition === 'start'"
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"
      >
        <span>
          {{ linkText }}
        </span>
      </span>

      <ng-template #notCurrentTitle>
        <span>
          <b>{{iconTooltipHeader || "Older Than Cutoff"}} </b>
        </span>
      </ng-template>
      <ng-template #notCurrentTemplate>
        <span
          [innerHTML]="iconTooltip || 'The last processed model is older than earnings.'"
          >
        </span>
        <br />
        <span>
          <a
            href="mailto:'{{ email }}'"
            class="tpr-consensus-email"
          >
            {{ email }}</a
          >
        </span>
      </ng-template>
    </span>
  `, isInline: true, styles: [".icon-link{font-size:14px;margin:0 2px;& va-icon:not(.disabled){cursor:pointer}& va-icon.disabled{pointer-events:none;color:#d3d7dd}svg {vertical-align: middle;}}.icon-text{font-size:12px;&.disabled{pointer-events:none;color:#d3d7dd}}.link-text{color:#1874ae;&:not(.disabled){cursor:pointer}&.disabled{pointer-events:none;color:#d3d7dd}}::ng-deep .va-tpr-consensus-popover{width:220px}.tpr-consensus-email{font-size:12px;font-weight:400;color:#3274a9;word-break:break-all}.tpr-consensus{align-items:center}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2$3.NzPopoverDirective, selector: "[nz-popover]", inputs: ["nzPopoverArrowPointAtCenter", "nzPopoverTitle", "nzPopoverContent", "nz-popover", "nzPopoverTrigger", "nzPopoverPlacement", "nzPopoverOrigin", "nzPopoverVisible", "nzPopoverMouseEnterDelay", "nzPopoverMouseLeaveDelay", "nzPopoverOverlayClassName", "nzPopoverOverlayStyle", "nzPopoverBackdrop"], outputs: ["nzPopoverVisibleChange"], exportAs: ["nzPopover"] }, { kind: "component", type: i3$2.IconComponent, selector: "va-icon", inputs: ["spin", "isFontAwesome", "styles", "size", "name"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TargetPricingConsensusRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'va-target-pricing-consensus-renderer', template: `
    <span
      *ngIf="show"
      class="tpr-consensus"
    >
      <span
        class="icon-text" 
        *ngIf="hasText && iconPosition === 'end' "
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"  
      >
        <span>
          {{ linkText }}
        </span>
      </span>
      <span
        class="icon-link"
        *ngIf="icon"
        [ngStyle]="{
          color: iconColor || '#1874ae'
        }"
      >
        <va-icon
          [size]="iconSize"
          [name]="icon"
          [ngClass]="{ 'disabled': isDisabled }"
          nz-popover
          [nzPopoverTitle]="notCurrentTitle"
          [nzPopoverContent]="notCurrentTemplate"
          nzPopoverTrigger="hover"
          nzPopoverPlacement="right"
          nzPopoverWidth="20px"
          [nzPopoverOverlayClassName]="'va-tpr-consensus-popover'"
          (click)="clickCallback(clickData)"
        ></va-icon>
      </span>
      <span
        class="icon-text"
        *ngIf="hasText && iconPosition === 'start'"
        (click)="clickCallback(clickData)"
        [ngClass]="{
          'link-text': !isTextNotLink,
          'disabled': isDisabled
        }"
      >
        <span>
          {{ linkText }}
        </span>
      </span>

      <ng-template #notCurrentTitle>
        <span>
          <b>{{iconTooltipHeader || "Older Than Cutoff"}} </b>
        </span>
      </ng-template>
      <ng-template #notCurrentTemplate>
        <span
          [innerHTML]="iconTooltip || 'The last processed model is older than earnings.'"
          >
        </span>
        <br />
        <span>
          <a
            href="mailto:'{{ email }}'"
            class="tpr-consensus-email"
          >
            {{ email }}</a
          >
        </span>
      </ng-template>
    </span>
  `, styles: [".icon-link{font-size:14px;margin:0 2px;& va-icon:not(.disabled){cursor:pointer}& va-icon.disabled{pointer-events:none;color:#d3d7dd}svg {vertical-align: middle;}}.icon-text{font-size:12px;&.disabled{pointer-events:none;color:#d3d7dd}}.link-text{color:#1874ae;&:not(.disabled){cursor:pointer}&.disabled{pointer-events:none;color:#d3d7dd}}::ng-deep .va-tpr-consensus-popover{width:220px}.tpr-consensus-email{font-size:12px;font-weight:400;color:#3274a9;word-break:break-all}.tpr-consensus{align-items:center}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { email: [{
                type: Input
            }], iconTooltipHeader: [{
                type: Input
            }], iconTooltip: [{
                type: Input
            }] } });

class DataCellRenderersModule {
}
DataCellRenderersModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataCellRenderersModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DataCellRenderersModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: DataCellRenderersModule, declarations: [DateRendererComponent,
        LinkRendererComponent,
        DownloadRendererComponent,
        PrintRendererComponent,
        AnalystRendererComponent,
        IconLinkRendererComponent,
        ReportingViewLinkRendererComponent,
        ReportingModelRendererComponent,
        MultiIconRendererComponent,
        // AlertGridActionRendererComponent,
        ReportingModelRendererComponent,
        CheckboxRendererComponent,
        BadgeRendererComponent,
        ColoredTextRendererComponent,
        TargetPricingLastChangeRendererComponent,
        TargetPricingAnalystRendererComponent,
        TargetPricingConsensusRendererComponent], imports: [CommonModule,
        FontAwesomeModule,
        HttpClientModule,
        NzToolTipModule,
        NzCheckboxModule,
        NzSpinModule,
        NzPopoverModule,
        NzOverlayModule,
        FormsModule,
        RouterModule,
        VaCommonModule,
        IconsModule], exports: [DateRendererComponent,
        LinkRendererComponent,
        DownloadRendererComponent,
        PrintRendererComponent,
        AnalystRendererComponent,
        IconLinkRendererComponent,
        ReportingViewLinkRendererComponent,
        ReportingModelRendererComponent,
        MultiIconRendererComponent,
        // AlertGridActionRendererComponent,
        ReportingModelRendererComponent,
        CheckboxRendererComponent,
        BadgeRendererComponent,
        ColoredTextRendererComponent,
        TargetPricingLastChangeRendererComponent,
        TargetPricingAnalystRendererComponent,
        TargetPricingConsensusRendererComponent] });
DataCellRenderersModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataCellRenderersModule, imports: [CommonModule,
        FontAwesomeModule,
        HttpClientModule,
        NzToolTipModule,
        NzCheckboxModule,
        NzSpinModule,
        NzPopoverModule,
        NzOverlayModule,
        FormsModule,
        RouterModule,
        VaCommonModule,
        IconsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DataCellRenderersModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DateRendererComponent,
                        LinkRendererComponent,
                        DownloadRendererComponent,
                        PrintRendererComponent,
                        AnalystRendererComponent,
                        IconLinkRendererComponent,
                        ReportingViewLinkRendererComponent,
                        ReportingModelRendererComponent,
                        MultiIconRendererComponent,
                        // AlertGridActionRendererComponent,
                        ReportingModelRendererComponent,
                        CheckboxRendererComponent,
                        BadgeRendererComponent,
                        ColoredTextRendererComponent,
                        TargetPricingLastChangeRendererComponent,
                        TargetPricingAnalystRendererComponent,
                        TargetPricingConsensusRendererComponent
                    ],
                    imports: [
                        CommonModule,
                        FontAwesomeModule,
                        HttpClientModule,
                        NzToolTipModule,
                        NzCheckboxModule,
                        NzSpinModule,
                        NzPopoverModule,
                        NzOverlayModule,
                        FormsModule,
                        RouterModule,
                        VaCommonModule,
                        IconsModule
                    ],
                    exports: [
                        DateRendererComponent,
                        LinkRendererComponent,
                        DownloadRendererComponent,
                        PrintRendererComponent,
                        AnalystRendererComponent,
                        IconLinkRendererComponent,
                        ReportingViewLinkRendererComponent,
                        ReportingModelRendererComponent,
                        MultiIconRendererComponent,
                        // AlertGridActionRendererComponent,
                        ReportingModelRendererComponent,
                        CheckboxRendererComponent,
                        BadgeRendererComponent,
                        ColoredTextRendererComponent,
                        TargetPricingLastChangeRendererComponent,
                        TargetPricingAnalystRendererComponent,
                        TargetPricingConsensusRendererComponent
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AnalystRendererComponent, BadgeRendererComponent, CheckboxRendererComponent, ColoredTextRendererComponent, DataCellRenderersModule, DateRendererComponent, DownloadRendererComponent, IconLinkRendererComponent, LinkRendererComponent, MultiIconRendererComponent, PrintRendererComponent, ReportingModelRendererComponent, ReportingViewLinkRendererComponent, TargetPricingAnalystRendererComponent, TargetPricingConsensusRendererComponent, TargetPricingLastChangeRendererComponent };
